import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { Icon, ChevronRightIcon } from 'components/shared/Icon/Icon'

import { AccordionContext } from './../../context'

import styles from './Header.module.scss'

export const Header = ({
  buttonClassName = undefined,
  className = undefined,
  title,
  children,
  wrapperClassName = undefined,
  onToggle,
}) => {
  const { handleToggle, isDisabled, isOpen } = React.useContext(
    AccordionContext,
  )

  return (
    <Box
      align="center"
      className={cx(styles.header, { [className]: Boolean(className) })}
    >
      <button
        className={cx(styles.button, {
          [buttonClassName]: Boolean(buttonClassName),
        })}
        disabled={isDisabled}
        {...(R.not(isDisabled) && {
          onClick: onToggle ? onToggle : handleToggle,
        })}
      >
        <Box
          align="center"
          className={cx(styles.wrapper, {
            [wrapperClassName]: Boolean(wrapperClassName),
          })}
          tagName="span"
        >
          <Icon
            className={cx(styles.chevron, { [styles.opened]: isOpen })}
            icon={ChevronRightIcon}
            size={24}
          />
          {title}
        </Box>
      </button>
      {children}
    </Box>
  )
}
